export const dummyProducts =[
    {
        "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "name": "High-Speed Blender",
        "slug": "high-speed-blender",
        "sku": "BLD001",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Momo-Maker-2.jpg",
        "description": "<p>This high-speed blender is perfect for making smoothies, soups, and sauces. With a powerful 1500W motor and stainless steel blades, it can handle even the toughest ingredients. Includes multiple speed settings and a durable glass jar.</p>",
        "gallery": [
            "https://thebetterappliances.com/wp-content/uploads/2023/03/Momo-Maker-2.jpg",
            "https://thebetterappliances.com/storage/media/products/high-speed-blender/gallery/blender-2.jpg",
            "https://thebetterappliances.com/storage/media/products/high-speed-blender/gallery/blender-3.jpg"
        ],
        "category_id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
        "brand_id": "3c4d5e6f-7g8h-9i0j-1k2l-m3n4o5p6q7r",
        "status": 1,
        "featured": 1,
        "trending": 1,
        "new": 1,
        "created_at": "2024-10-01T10:00:00.000000Z",
        "updated_at": "2024-10-05T12:00:00.000000Z",
        "sub_category_id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
        "sub_sub_category_id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "stock": 1,
        "weekly_deal": 0,
        "variations": [
            {
                "id": "6f7g8h9i-0j1k-2l3m-4n5o-p6q7r8s9t0u",
                "product_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
                "size_id": "7g8h9i0j-1k2l-3m4n-5o6p-q7r8s9t0u1v",
                "color_id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
                "price": "8999",
                "selling_price": "7999",
                "created_at": "2024-10-05T12:00:00.000000Z",
                "updated_at": "2024-10-05T12:00:00.000000Z",
                "stock": 1,
                "size": {
                    "id": "7g8h9i0j-1k2l-3m4n-5o6p-q7r8s9t0u1v",
                    "name": "Standard",
                    "category": null
                },
                "color": {
                    "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
                    "name": "Black"
                }
            },
            {
                "id": "9i0j1k2l-3m4n-5o6p-7q8r-s9t0u1v2w3x",
                "product_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
                "size_id": "0j1k2l3m-4n5o-6p7q-8r9s-t0u1v2w3x4y",
                "color_id": "1k2l3m4n-5o6p-7q8r-9s0t-u1v2w3x4y5z",
                "price": "8999",
                "selling_price": "7999",
                "created_at": "2024-10-05T12:00:00.000000Z",
                "updated_at": "2024-10-05T12:00:00.000000Z",
                "stock": 1,
                "size": {
                    "id": "0j1k2l3m-4n5o-6p7q-8r9s-t0u1v2w3x4y",
                    "name": "Standard",
                    "category": null
                },
                "color": {
                    "id": "1k2l3m4n-5o6p-7q8r-9s0t-u1v2w3x4y5z",
                    "name": "Red"
                }
            }
        ],
        "category": {
            "id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
            "name": "Kitchen Appliances",
            "slug": "kitchen-appliances",
            "parent": null
        },
        "brand": {
            "id": "3c4d5e6f-7g8h-9i0j-1k2l-m3n4o5p6q7r",
            "name": "BlendMaster",
            "slug": "blendmaster"
        },
        "sub_category": {
            "id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
            "name": "Blenders",
            "slug": "blenders",
            "parent": null
        },
        "sub_sub_category": {
            "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
            "name": "High-Speed Blenders",
            "slug": "high-speed-blenders",
            "parent": null
        },
        "tags": [
            {
                "name": "Blender",
                "slug": "blender",
                "pivot": {
                    "product_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
                    "tag_id": "2l3m4n5o-6p7q-8r9s-0t1u-v2w3x4y5z6a"
                }
            },
            {
                "name": "Kitchen",
                "slug": "kitchen",
                "pivot": {
                    "product_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
                    "tag_id": "3m4n5o6p-7q8r-9s0t-1u2v-w3x4y5z6a7b"
                }
            }
        ]
    },
    {
        "id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
        "name": "Air Fryer Pro",
        "slug": "air-fryer-pro",
        "sku": "AFR002",
        "photo": "https://thebetterappliances.com/storage/media/products/air-fryer-pro/air-fryer.jpg",
        "description": "<p>The Air Fryer Pro is a versatile kitchen appliance that allows you to fry, bake, and roast with little to no oil. With a 5.5L capacity and digital controls, it's perfect for healthy cooking. Includes a recipe book for beginners.</p>",
        "gallery": [
            "https://thebetterappliances.com/storage/media/products/air-fryer-pro/gallery/air-fryer-1.jpg",
            "https://thebetterappliances.com/storage/media/products/air-fryer-pro/gallery/air-fryer-2.jpg",
            "https://thebetterappliances.com/storage/media/products/air-fryer-pro/gallery/air-fryer-3.jpg"
        ],
        "category_id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
        "brand_id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
        "status": 1,
        "featured": 1,
        "trending": 1,
        "new": 1,
        "created_at": "2024-10-02T11:00:00.000000Z",
        "updated_at": "2024-10-06T13:00:00.000000Z",
        "sub_category_id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "sub_sub_category_id": "6f7g8h9i-0j1k-2l3m-4n5o-p6q7r8s9t0u",
        "stock": 1,
        "weekly_deal": 1,
        "variations": [
            {
                "id": "7g8h9i0j-1k2l-3m4n-5o6p-q7r8s9t0u1v",
                "product_id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
                "size_id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
                "color_id": "9i0j1k2l-3m4n-5o6p-7q8r-s9t0u1v2w3x",
                "price": "6999",
                "selling_price": "6299",
                "created_at": "2024-10-06T13:00:00.000000Z",
                "updated_at": "2024-10-06T13:00:00.000000Z",
                "stock": 1,
                "size": {
                    "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
                    "name": "5.5L",
                    "category": null
                },
                "color": {
                    "id": "9i0j1k2l-3m4n-5o6p-7q8r-s9t0u1v2w3x",
                    "name": "Silver"
                }
            }
        ],
        "category": {
            "id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
            "name": "Kitchen Appliances",
            "slug": "kitchen-appliances",
            "parent": null
        },
        "brand": {
            "id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
            "name": "FryTech",
            "slug": "frytech"
        },
        "sub_category": {
            "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
            "name": "Air Fryers",
            "slug": "air-fryers",
            "parent": null
        },
        "sub_sub_category": {
            "id": "6f7g8h9i-0j1k-2l3m-4n5o-p6q7r8s9t0u",
            "name": "Digital Air Fryers",
            "slug": "digital-air-fryers",
            "parent": null
        },
        "tags": [
            {
                "name": "Air Fryer",
                "slug": "air-fryer",
                "pivot": {
                    "product_id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
                    "tag_id": "4n5o6p7q-8r9s-0t1u-2v3w-x4y5z6a7b8c"
                }
            },
            {
                "name": "Healthy Cooking",
                "slug": "healthy-cooking",
                "pivot": {
                    "product_id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
                    "tag_id": "5o6p7q8r-9s0t-1u2v-3w4x-y5z6a7b8c9d"
                }
            }
        ]
    }
]



export const dummyCategories =[
    {
        "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "name": "Kitchen Appliances",
        "slug": "kitchen-appliances",
        "order": 1,
        "description": "Explore a wide range of kitchen appliances to make cooking easier and more efficient. From blenders to air fryers, find the perfect tools for your kitchen.",
        "title": "Kitchen Essentials",
        "parent_id": null,
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Madhani.jpg",
        "created_at": "2024-10-01T10:00:00.000000Z",
        "updated_at": "2024-10-05T12:00:00.000000Z",
        "show_image": 1,
        "parent": null
    },
    {
        "id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
        "name": "Blenders",
        "slug": "blenders",
        "order": 2,
        "description": "High-performance blenders for smoothies, soups, and more. Perfect for healthy living and quick meal prep.",
        "title": "Blenders",
        "parent_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Madhani.jpg",
        "created_at": "2024-10-02T11:00:00.000000Z",
        "updated_at": "2024-10-06T13:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
            "name": "Kitchen Appliances",
            "slug": "kitchen-appliances",
            "order": 1,
            "description": "Explore a wide range of kitchen appliances to make cooking easier and more efficient. From blenders to air fryers, find the perfect tools for your kitchen.",
            "title": "Kitchen Essentials",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Madhani.jpg",
            "created_at": "2024-10-01T10:00:00.000000Z",
            "updated_at": "2024-10-05T12:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "3c4d5e6f-7g8h-9i0j-1k2l-m3n4o5p6q7r",
        "name": "Air Fryers",
        "slug": "air-fryers",
        "order": 3,
        "description": "Healthy cooking made easy with our range of air fryers. Fry, bake, and roast with little to no oil.",
        "title": "Air Fryers",
        "parent_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "photo": "https://thebetterappliances.com/storage/media/categories/air-fryers.jpg",
        "created_at": "2024-10-03T12:00:00.000000Z",
        "updated_at": "2024-10-07T14:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
            "name": "Kitchen Appliances",
            "slug": "kitchen-appliances",
            "order": 1,
            "description": "Explore a wide range of kitchen appliances to make cooking easier and more efficient. From blenders to air fryers, find the perfect tools for your kitchen.",
            "title": "Kitchen Essentials",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/kitchen-appliances.jpg",
            "created_at": "2024-10-01T10:00:00.000000Z",
            "updated_at": "2024-10-05T12:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
        "name": "Coffee Makers",
        "slug": "coffee-makers",
        "order": 4,
        "description": "Brew the perfect cup of coffee with our selection of coffee makers. From drip coffee to espresso machines, we have it all.",
        "title": "Coffee Makers",
        "parent_id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "photo": "https://thebetterappliances.com/storage/media/categories/coffee-makers.jpg",
        "created_at": "2024-10-04T13:00:00.000000Z",
        "updated_at": "2024-10-08T15:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
            "name": "Kitchen Appliances",
            "slug": "kitchen-appliances",
            "order": 1,
            "description": "Explore a wide range of kitchen appliances to make cooking easier and more efficient. From blenders to air fryers, find the perfect tools for your kitchen.",
            "title": "Kitchen Essentials",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/kitchen-appliances.jpg",
            "created_at": "2024-10-01T10:00:00.000000Z",
            "updated_at": "2024-10-05T12:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "name": "Home Appliances",
        "slug": "home-appliances",
        "order": 5,
        "description": "Upgrade your home with our range of home appliances. From vacuum cleaners to air purifiers, we have everything you need.",
        "title": "Home Essentials",
        "parent_id": null,
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Madhani.jpg",
        "created_at": "2024-10-05T14:00:00.000000Z",
        "updated_at": "2024-10-09T16:00:00.000000Z",
        "show_image": 1,
        "parent": null
    },
    {
        "id": "6f7g8h9i-0j1k-2l3m-4n5o-p6q7r8s9t0u",
        "name": "Vacuum Cleaners",
        "slug": "vacuum-cleaners",
        "order": 6,
        "description": "Keep your home spotless with our powerful vacuum cleaners. Designed for efficiency and ease of use.",
        "title": "Vacuum Cleaners",
        "parent_id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "photo": "https://thebetterappliances.com/storage/media/categories/vacuum-cleaners.jpg",
        "created_at": "2024-10-06T15:00:00.000000Z",
        "updated_at": "2024-10-10T17:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
            "name": "Home Appliances",
            "slug": "home-appliances",
            "order": 5,
            "description": "Upgrade your home with our range of home appliances. From vacuum cleaners to air purifiers, we have everything you need.",
            "title": "Home Essentials",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/home-appliances.jpg",
            "created_at": "2024-10-05T14:00:00.000000Z",
            "updated_at": "2024-10-09T16:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "7g8h9i0j-1k2l-3m4n-5o6p-q7r8s9t0u1v",
        "name": "Air Purifiers",
        "slug": "air-purifiers",
        "order": 7,
        "description": "Breathe cleaner air with our advanced air purifiers. Perfect for homes and offices.",
        "title": "Air Purifiers",
        "parent_id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "photo": "https://thebetterappliances.com/storage/media/categories/air-purifiers.jpg",
        "created_at": "2024-10-07T16:00:00.000000Z",
        "updated_at": "2024-10-11T18:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
            "name": "Home Appliances",
            "slug": "home-appliances",
            "order": 5,
            "description": "Upgrade your home with our range of home appliances. From vacuum cleaners to air purifiers, we have everything you need.",
            "title": "Home Essentials",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/home-appliances.jpg",
            "created_at": "2024-10-05T14:00:00.000000Z",
            "updated_at": "2024-10-09T16:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
        "name": "Cleaning Tools",
        "slug": "cleaning-tools",
        "order": 8,
        "description": "Make cleaning a breeze with our range of cleaning tools. From mops to scrubbers, we have everything you need.",
        "title": "Cleaning Tools",
        "parent_id": null,
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/03/Madhani.jpg",
        "created_at": "2024-10-08T17:00:00.000000Z",
        "updated_at": "2024-10-12T19:00:00.000000Z",
        "show_image": 1,
        "parent": null
    },
    {
        "id": "9i0j1k2l-3m4n-5o6p-7q8r-s9t0u1v2w3x",
        "name": "Mops and Brooms",
        "slug": "mops-and-brooms",
        "order": 9,
        "description": "Keep your floors clean with our durable mops and brooms. Designed for efficiency and ease of use.",
        "title": "Mops and Brooms",
        "parent_id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
        "photo": "https://thebetterappliances.com/storage/media/categories/mops-and-brooms.jpg",
        "created_at": "2024-10-09T18:00:00.000000Z",
        "updated_at": "2024-10-13T20:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
            "name": "Cleaning Tools",
            "slug": "cleaning-tools",
            "order": 8,
            "description": "Make cleaning a breeze with our range of cleaning tools. From mops to scrubbers, we have everything you need.",
            "title": "Cleaning Tools",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/cleaning-tools.jpg",
            "created_at": "2024-10-08T17:00:00.000000Z",
            "updated_at": "2024-10-12T19:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    },
    {
        "id": "0j1k2l3m-4n5o-6p7q-8r9s-t0u1v2w3x4y",
        "name": "Scrubbers and Sponges",
        "slug": "scrubbers-and-sponges",
        "order": 10,
        "description": "Tackle tough stains with our durable scrubbers and sponges. Perfect for kitchens and bathrooms.",
        "title": "Scrubbers and Sponges",
        "parent_id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
        "photo": "https://thebetterappliances.com/storage/media/categories/scrubbers-and-sponges.jpg",
        "created_at": "2024-10-10T19:00:00.000000Z",
        "updated_at": "2024-10-14T21:00:00.000000Z",
        "show_image": 1,
        "parent": {
            "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
            "name": "Cleaning Tools",
            "slug": "cleaning-tools",
            "order": 8,
            "description": "Make cleaning a breeze with our range of cleaning tools. From mops to scrubbers, we have everything you need.",
            "title": "Cleaning Tools",
            "parent_id": null,
            "photo": "https://thebetterappliances.com/storage/media/categories/cleaning-tools.jpg",
            "created_at": "2024-10-08T17:00:00.000000Z",
            "updated_at": "2024-10-12T19:00:00.000000Z",
            "show_image": 1,
            "parent": null
        }
    }
]


export const dummyBrands =[
    {
        "id": "1a2b3c4d-5e6f-7g8h-9i0j-k1l2m3n4o5p",
        "name": "KitchenAid",
        "slug": "kitchenaid",
        "description": "KitchenAid is a trusted brand known for its high-quality kitchen appliances, including stand mixers, blenders, and food processors.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2024/05/Booster-800x800.jpg",
        "created_at": "2024-10-01T10:00:00.000000Z",
        "updated_at": "2024-10-05T12:00:00.000000Z"
    },
    {
        "id": "2b3c4d5e-6f7g-8h9i-0j1k-l2m3n4o5p6q",
        "name": "Ninja",
        "slug": "ninja",
        "description": "Ninja offers a wide range of kitchen appliances, including air fryers, blenders, and coffee makers, designed for efficiency and convenience.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-02T11:00:00.000000Z",
        "updated_at": "2024-10-06T13:00:00.000000Z"
    },
    {
        "id": "3c4d5e6f-7g8h-9i0j-1k2l-m3n4o5p6q7r",
        "name": "Dyson",
        "slug": "dyson",
        "description": "Dyson is a leading brand in home appliances, known for its innovative vacuum cleaners, air purifiers, and hair care products.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-03T12:00:00.000000Z",
        "updated_at": "2024-10-07T14:00:00.000000Z"
    },
    {
        "id": "4d5e6f7g-8h9i-0j1k-2l3m-n4o5p6q7r8s",
        "name": "Breville",
        "slug": "breville",
        "description": "Breville specializes in premium kitchen appliances, including coffee makers, toasters, and juicers, designed for culinary enthusiasts.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-04T13:00:00.000000Z",
        "updated_at": "2024-10-08T15:00:00.000000Z"
    },
    {
        "id": "5e6f7g8h-9i0j-1k2l-3m4n-o5p6q7r8s9t",
        "name": "Shark",
        "slug": "shark",
        "description": "Shark is a popular brand for home cleaning appliances, offering powerful vacuum cleaners, steam mops, and air purifiers.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-05T14:00:00.000000Z",
        "updated_at": "2024-10-09T16:00:00.000000Z"
    },
    {
        "id": "6f7g8h9i-0j1k-2l3m-4n5o-p6q7r8s9t0u",
        "name": "Philips",
        "slug": "philips",
        "description": "Philips offers a wide range of home and kitchen appliances, including air fryers, blenders, and air purifiers, known for their reliability and innovation.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-06T15:00:00.000000Z",
        "updated_at": "2024-10-10T17:00:00.000000Z"
    },
    {
        "id": "7g8h9i0j-1k2l-3m4n-5o6p-q7r8s9t0u1v",
        "name": "Cuisinart",
        "slug": "cuisinart",
        "description": "Cuisinart is a trusted brand for kitchen appliances, offering products like food processors, coffee makers, and griddles for home chefs.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-07T16:00:00.000000Z",
        "updated_at": "2024-10-11T18:00:00.000000Z"
    },
    {
        "id": "8h9i0j1k-2l3m-4n5o-6p7q-r8s9t0u1v2w",
        "name": "iRobot",
        "slug": "irobot",
        "description": "iRobot is a leader in robotic cleaning solutions, offering products like the Roomba vacuum cleaners and Braava mopping robots.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-08T17:00:00.000000Z",
        "updated_at": "2024-10-12T19:00:00.000000Z"
    },
    {
        "id": "9i0j1k2l-3m4n-5o6p-7q8r-s9t0u1v2w3x",
        "name": "Instant Pot",
        "slug": "instant-pot",
        "description": "Instant Pot revolutionized home cooking with its multi-functional pressure cookers, air fryers, and slow cookers.",
        "photo": "https://thebetterappliances.com/storage/media/brands/instant-pot-logo.png",
        "created_at": "2024-10-09T18:00:00.000000Z",
        "updated_at": "2024-10-13T20:00:00.000000Z"
    },
    {
        "id": "0j1k2l3m-4n5o-6p7q-8r9s-t0u1v2w3x4y",
        "name": "Hamilton Beach",
        "slug": "hamilton-beach",
        "description": "Hamilton Beach offers affordable and reliable kitchen appliances, including blenders, coffee makers, and toasters.",
        "photo": "https://thebetterappliances.com/wp-content/uploads/2023/06/SUPER-LITE-800x800.jpg",
        "created_at": "2024-10-10T19:00:00.000000Z",
        "updated_at": "2024-10-14T21:00:00.000000Z"
    }
]
